/**
 * Pure helpers for Jira ↔ GitHub cross-card linking.
 */

import type { AttentionItem, CrossReference } from './types';

/** True when a GitHub attention item is linked to the given Jira ticket key. */
export function githubItemLinksTicket(item: AttentionItem, ticketKey: string): boolean {
  if (item.source !== 'github') return false;
  const key = ticketKey.trim();
  if (!key) return false;
  if (item.ticket === key) return true;
  return Boolean(item.refs?.some((ref) => ref.key === key));
}

/** GitHub PRs linked to a Jira ticket (by ticket field or refs). */
export function getGitHubItemsByTicket(
  items: readonly AttentionItem[],
  ticketKey: string | undefined,
): AttentionItem[] {
  if (!ticketKey?.trim()) return [];
  return items.filter((item) => githubItemLinksTicket(item, ticketKey));
}

/** Build CrossReference chips for ticket keys detected on a PR. */
export function buildGitHubTicketRefs(keys: readonly string[]): CrossReference[] {
  return keys.map((key, index) => ({
    key,
    grade: index === 0 ? 'explícita' : 'inferida',
    why: index === 0 ? 'Detectado en el PR' : 'También referenciado',
  }));
}

/** Merge mapper/meta refs with linkedTicketKey so cards always show navigation chips. */
export function resolveGitHubAttentionRefs(
  linkedTicketKey: string | undefined,
  existingRefs: CrossReference[] | undefined,
): CrossReference[] | undefined {
  if (existingRefs && existingRefs.length > 0) return existingRefs;
  if (!linkedTicketKey?.trim()) return undefined;
  return buildGitHubTicketRefs([linkedTicketKey.trim()]);
}
